module.exports = __webpack_public_path__ + "static/media/popup_200814.7b7e52ec.png";